import { RouterType } from '@online-webinar/router';
import { ChatMessages } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/chat-messages'].update({
        staticData: { title: { page: 'Insights.Chat.PageHeading', forWebinar: true } },
        component: authGuard(ChatMessages, { canBroadcast: true })
    });
};
